import { lazy, Suspense } from 'react'
import { RouteObject } from 'react-router'
import { Spin } from 'antd'
import { ProtectedRoutes } from '@/router/ProtectedRoutes.tsx'

const DeferralsPage = lazy(() => import('./deferrals/index.tsx'))
const BalancesPaymentsReversalsPage = lazy(() => import('./balances-payments-reversals/index.tsx'))
const EmployeesPage = lazy(() => import('./employees/index.tsx'))
const FundsPage = lazy(() => import('./funds/index.tsx'))
const PmDeferralsPage = lazy(() => import('./pm-deferrals/index.tsx'))
const VestingRulesPage = lazy(() => import('./vesting-rules/index.tsx'))
const VestingDetailsPage = lazy(() => import('./vesting-details/index.tsx'))
const AllVestingDetailsPage = lazy(() => import('./all-vesting-details/index.tsx'))
const AuditLogPage = lazy(() => import('./audit-log/index.tsx'))
const TypicalMonthSopPage = lazy(() => import('./typical-month-sop/index.tsx'))
const ChangeRequestsPage = lazy(() => import('./change-requests/index.tsx'))

export const deferredBonusesRoutes: RouteObject = {
  path: 'deferred-bonuses',
  element: <ProtectedRoutes requiredPermissions={[{ moduleName: 'deferred-bonus', functionName: 'manage-deferred-bonuses' }]} />,
  children: [
    { index: true, element: <Suspense fallback={<Spin />}><DeferralsPage /></Suspense> },
    { path: 'pm-deferrals/:employeeId', element: <Suspense fallback={<Spin />}><PmDeferralsPage /></Suspense> },
    { path: 'employees', element: <Suspense fallback={<Spin />}><EmployeesPage /></Suspense> },
    { path: 'funds', element: <Suspense fallback={<Spin />}><FundsPage /></Suspense> },
    { path: ':deferralId/balances-payments-reversals', element: <Suspense fallback={<Spin />}><BalancesPaymentsReversalsPage /></Suspense> },
    { path: 'vesting-rules', element: <Suspense fallback={<Spin />}><VestingRulesPage /></Suspense> },
    { path: 'all-vesting-details', element: <Suspense fallback={<Spin />}><AllVestingDetailsPage /></Suspense> },
    { path: ':deferralId/vesting-details', element: <Suspense fallback={<Spin />}><VestingDetailsPage /></Suspense> },
    { path: 'audit-log', element: <Suspense fallback={<Spin />}><AuditLogPage /></Suspense> },
    { path: 'typical-month-sop', element: <Suspense fallback={<Spin />}><TypicalMonthSopPage /></Suspense> },
    { path: 'change-requests', element: <Suspense fallback={<Spin />}><ChangeRequestsPage /></Suspense> },
  ],
}